<template>
  <footer class="text-white fixed-bottom">
    <div class="footerStyles footerContainer">
      <div>&nbsp;</div>
      <div tabindex="0" class="footerText" aria-label="Copyright DLA © 2025 CAAMS - Civilian Arming Authorization Management System | v3.0.1 | Powered by JCXS">
        Copyright DLA © 2025 CAAMS - Civilian Arming Authorization Management System | v3.0.1 | Powered by
        <span tabindex="0" class="jsxsButtonHover"  @keydown.enter="jcxs" 
          onclick="window.open('https://www.jccs.gov/', '_blank', 'resizable=no,scrollbars=yes,status=no,width=800, height=750');" type="button" role="button">JCXS</span>
      </div>
      <div>
        <button class="btn btn-primary helpBtnMargin helpBtnSizing" @click="hde()" role="button" aria-label="Helpdesk and Feedback" type="button">Helpdesk &
          Feedback</button>

      </div>
    </div>
  </footer>
</template>

<script>
import { store } from "../../store/store.js";

export default {
  name: "AppFooter",
  data() {
    return {
      store,
    };
  },
  methods: {
    hde() {
      window.open('https://www.jccs.gov/HDPlus/Ext/App?Name=CAAMS&email=' + store.authenticatedUser.email,
        "mywindow", "resizable=no,scrollbars=yes,status=no,width=800, height=750");
      },
      jcxs() {
          window.open('https://www.jccs.gov',
              "mywindow", "resizable=no,scrollbars=yes,status=no,width=800, height=750");
      }
  }
};
</script>

<style scoped>
.jsxsButtonHover:Hover {
  color: red;
  text-decoration: underline;
}

.footerContainer {
  margin-top: 0px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding-top: 5px;
  padding-bottom: 5px;
}

.helpBtnMargin {
  margin-right: 5px;
}

.helpBtnSizing {
  font-size: 16px;
  padding: 6px;
}

.footerText {
  font-size: 16px;
  flex-wrap: nowrap;
}

.footerStyles {
  background-image: linear-gradient(to right, #1063a8, #003a6c);
  color: rgb(200, 199, 199);
}

footer {
  /* This calculation takes the viewport width minus the difference in the viewport width and 100% width (this accounts for the vertical scrollbar's width) */
  width: calc(100vw - (100vw - 100%));
  overflow-x: hidden;
}
</style>
